import { episodeOutputFields } from './episodeOutputMeta';
import { spatialZoneOutputFields } from './spatialZoneOutputMeta';

const TIME_LIKE_OUTPUT_BASES = new Set([
  'periodo',
  'time',
  'timestamp',
  'inicio',
  'fin',
  'dia',
  'hora_inicio',
]);

function isTimeLikeOutputBase(base) {
  const b = String(base || '').toLowerCase();
  if (TIME_LIKE_OUTPUT_BASES.has(b)) return true;
  return b.includes('periodo') || b.includes('time') || b.includes('fecha');
}

function fieldLabel(f) {
  return f.value === f.base ? String(f.base).replace(/_/g, ' ') : f.value;
}

/** Columnas fecha/hora de la fuente del gráfico (episodios, zonas o serie SQL). */
export function buildChartFeedDatetimeFieldOptions({
  chartFeed,
  episodeAnalysis,
  episodeGroupCols,
  spatialZoneAnalysis,
  spatialZoneGroupCols,
  columns,
  context,
  resolvePlainColumnAliases,
  headerLabel,
  getColumnMeta,
}) {
  if (chartFeed === 'episodes') {
    return episodeOutputFields(episodeAnalysis, episodeGroupCols)
      .filter((f) => isTimeLikeOutputBase(f.base))
      .map((f) => ({ value: f.value, label: fieldLabel(f) }));
  }
  if (chartFeed === 'zones') {
    return spatialZoneOutputFields(spatialZoneAnalysis, spatialZoneGroupCols)
      .filter((f) => isTimeLikeOutputBase(f.base))
      .map((f) => ({ value: f.value, label: fieldLabel(f) }));
  }
  const opts = [];
  // Usa el mismo alias desambiguado que Eje X/Y/Series, para que dos
  // columnas de fecha con la misma base y distinto agrupamiento no compartan value.
  const plainAliases = resolvePlainColumnAliases(columns);
  (columns || []).forEach((c, i) => {
    if (!c?.tableId || !c?.column) return;
    const meta = getColumnMeta(context, c);
    if (meta?.logicalType !== 'datetime' && meta?.logicalType !== 'date') return;
    opts.push({
      value: plainAliases[i],
      label: headerLabel(c, context),
    });
  });
  return opts;
}

/** Columna de hora por defecto para turnos según la fuente del gráfico. */
export function guessSeriesTimeRangeSourceField({
  chartFeed,
  episodeAnalysis,
  episodeGroupCols,
  spatialZoneAnalysis,
  spatialZoneGroupCols,
  columns,
  filters,
  setId,
  context,
  vizXField,
  fieldAlias,
  getColumnMeta,
  guessSqlTimeRangeSourceField,
}) {
  const pickFromFields = (fields) => {
    if (!fields?.length) return '';
    if (vizXField && fields.some((f) => f.value === vizXField)) return vizXField;
    const preferred = ['inicio', 'hora_inicio', 'periodo', 'dia', 'time'];
    for (const base of preferred) {
      const hit = fields.find((f) => String(f.base).toLowerCase() === base);
      if (hit) return hit.value;
    }
    return fields[0].value;
  };

  if (chartFeed === 'episodes') {
    const fields = episodeOutputFields(episodeAnalysis, episodeGroupCols).filter((f) =>
      isTimeLikeOutputBase(f.base)
    );
    const picked = pickFromFields(fields);
    if (picked) return picked;
  }
  if (chartFeed === 'zones') {
    const fields = spatialZoneOutputFields(spatialZoneAnalysis, spatialZoneGroupCols).filter((f) =>
      isTimeLikeOutputBase(f.base)
    );
    const picked = pickFromFields(fields);
    if (picked) return picked;
  }
  return guessSqlTimeRangeSourceField(columns, filters, setId, context);
}

export function seriesTimeRangeLabelAlias(setId) {
  const base = String(setId || 'series')
    .replace(/[^a-zA-Z0-9_]/g, '_')
    .slice(0, 50);
  return `${base || 'series'}_rango`;
}
